// src/data/blogPosts/nextcloud-kalender-funktionen.js

import React from 'react';

// Step 2: Import images
// import thumbnailImage from '../../assets/images/blog/your-post-featured.png';


// Step 3: Import blog components
import { 
  BlogContent, 
  BlogHeading, 
  BlogImage,
  BlogGallery,
  BlogSection
} from '../../components/blog';

/**
 * Blog post about Nextcloud Kalender Funktionen
 */
const post = {
  // Step 4: Set basic metadata
  id: 'nextcloud-kalender-funktionen',
  slug: 'nextcloud-kalender-funktionen',
  
  date: "2025-07-22T00:00:00.000Z",
  readTime: 7,
  categories: ["Anleitungen", "Open Source Software"],
  thumbnail: "/images/blog/calendar_application.png",
  thumbnailUrl: "https://pathconnect.eu/images/blog/calendar_application.png",
  thumbnailSize: 'medium',
  showInPostHeader: true,
  likes: 0,
  comments: [],
  
  searchableContent: "Nextcloud Kalender, Termine, Talk, Ressourcen, Terminplan, Kalender teilen, wiederkehrende Termine, Zeit finden, PathConnect",

  translations: {
    de: {
      title: "Nextcloud Kalender – Die wichtigsten Funktionen im Überblick",
      formattedDate: "22. Juli 2025",
      excerpt: "Der Nextcloud-Kalender ermöglicht dir eine einfache und datenschutzfreundliche Organisation von Terminen, Meetings und Ressourcen. Im Folgenden stellen wir dir die zentralen Funktionen vor, die deine tägliche Zusammenarbeit erleichtern.",
      searchableContent: "Nextcloud Kalender, Termine, Talk, Ressourcen, Terminplan, Kalender teilen, wiederkehrende Termine, Zeit finden, PathConnect",
      content: () => (
        <BlogContent>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Nextcloud Kalender – Die wichtigsten Funktionen im Überblick</h1>
          <p>Der Nextcloud-Kalender ermöglicht dir eine einfache und datenschutzfreundliche Organisation von Terminen, Meetings und Ressourcen. Im Folgenden stellen wir dir die zentralen Funktionen vor, die deine tägliche Zusammenarbeit erleichtern.</p>
          
          <BlogHeading>Kalender erstellen</BlogHeading>
          <p>Über das Kalender-Icon in der Weboberfläche kannst du beliebig viele Kalender für verschiedene Zwecke erstellen und sie individuell benennen. Klicke dazu in der Kalender-App auf das „+“-Symbol, gib einen Namen ein und bestätige.</p>
         <BlogImage 
            src="/images/blog/Neuer Kalender.png"
            alt="Kalender hinzufügen"
            size="medium"
            className="max-w-[420px] mx-auto"
            caption="Kalender hinzufügen"
            />
          
          <BlogHeading>Kalender teilen</BlogHeading>
          <p>Du kannst deinen Kalender gezielt mit einzelnen Personen oder Gruppen teilen. Dabei bestimmst du, ob diese nur die Termine ansehen oder auch bearbeiten dürfen. Die Freigabe funktioniert sowohl für interne Nutzer als auch für externe Kontakte.</p>
          <p>Klicke neben dem Kalendernamen auf das Stift-Symbol, um den Kalender zu bearbeiten. In diesem Fenster kannst du einen neuen Namen festlegen und den Kalender mit anderen teilen, indem du deren Namen oder Gruppe eingibst.</p>
            <BlogImage 
            src="/images/blog/Kalender teilen.png"
            alt="Kalender teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Kalender teilen"
            />
          
          <BlogHeading>Termin erstellen mit Talk-Raum & Teilnehmer einladen</BlogHeading>
          <p>Beim Anlegen eines Termins kannst du direkt einen Nextcloud-Talk-Raum integrieren. Der Link zur Videokonferenz wird allen eingeladenen Teilnehmern automatisch zur Verfügung gestellt. Teilnehmer können per Benutzername oder E-Mail-Adresse hinzugefügt werden – die Einladung landet direkt im jeweiligen Kalender.</p>
          <p>Du kannst einen neuen Kalendereintrag entweder durch Klick auf den Button „+ Ereignis“ oder durch Klick auf ein freies Feld im Kalender erstellen. In beiden Fällen öffnet sich ein neues Fenster. Klicke hier am besten gleich auf den Button „Weitere Einzelheiten“, um alle Optionen zu sehen.</p>

          <p>In dieser Übersicht hast du die Möglichkeit, dem Termin einen Talk-Raum hinzuzufügen. Du hast die Wahl zwischen einem neuen Raum und einem bereits vorhandenen. Ein entsprechender Link wird dem Termin angefügt.</p>
          <p>Unter dem Reiter „Teilnehmer” kannst du weitere Teilnehmer hinzufügen. Gib dazu entweder die E-Mail-Adresse, den Benutzernamen oder einen Kontakt an.</p>
            <BlogGallery
            images={[
                { src: "/images/blog/Neuer Termin.png", alt: "Neuer Termin", className: "max-w-[360px] mx-auto" },
                { src: "/images/blog/Termin Einzelheiten.png", alt: "Termin Einzelheiten", className: "max-w-[360px] mx-auto" }
            ]}
            />

          
          <BlogHeading>Wiederkehrende Termine hinzufügen</BlogHeading>
          <p>Wiederkehrende Termine lassen sich in Nextcloud ganz einfach erstellen. Beim Erstellen eines neuen Termins kannst du festlegen, ob und wie oft er sich wiederholen soll, beispielsweise täglich, wöchentlich, monatlich oder nach einem individuellen Rhythmus. Das ist ideal für regelmäßige Meetings oder sich wiederholende Aufgaben.</p>
          <p>Die Option findest du unter dem Reiter „Details“. Standardmäßig wiederholt sich ein Termin nicht. Um das zu ändern, klickst du auf das Stift-Symbol und wählst das gewünschte Wiederholungsintervall aus.</p>
            <BlogImage 
            src="/images/blog/Termin wiederholen.png"
            alt="Kalender teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Kalender teilen"
            />
          
          <BlogHeading>Zeit finden („Terminplanungsassistent“)</BlogHeading>
          <p>Mithilfe der Funktion „Zeit finden“ kannst du bei der Terminerstellung ganz einfach prüfen, ob die eingeladenen Teilnehmer im gewünschten Zeitraum verfügbar sind oder bereits andere Termine haben. Dabei werden die Details anderer Termine nicht angezeigt, sondern es wird nur angezeigt, ob jemand frei oder belegt ist. Das erleichtert die gemeinsame Terminplanung enorm.</p>
          <p>Um den Button „Zeit finden“ nutzen zu können, muss zuvor mindestens eine Person dem Termin hinzugefügt worden sein. In der sich öffnenden Übersicht werden dann die Zeiten angezeigt, in denen der andere Teilnehmer bereits Termine hat, sowie die freien Zeitslots.</p>
            <BlogImage 
            src="/images/blog/Zeitslot.png"
            alt="Kalender teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Kalender teilen"
            />
          
          <BlogHeading>Ressourcen (Räume hinzufügen)</BlogHeading>
          <p>Mit Nextcloud kannst du bei der Terminerstellung sogenannte Ressourcen (z. B. Konferenzräume) direkt buchen. Sobald du einen Raum oder eine andere Ressource als Teilnehmer hinzufügst, prüft Nextcloud automatisch die Verfügbarkeit. Nur freie Ressourcen können für deinen Termin ausgewählt werden, sodass Doppelbuchungen ausgeschlossen sind.</p>
          <p>Diese Option findest du unter dem Punkt „Ressourcen“. Es werden dir freie Räume vorgeschlagen. Du kannst aber auch selbst nach Räumen suchen und sie über das „Plus-Symbol“ zum Termin hinzufügen.</p>
           <BlogImage 
            src="/images/blog/Ressource hinzufügen.png"
            alt="Kalender teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Kalender teilen"
            />
          
          <BlogHeading>Terminpläne</BlogHeading>
          <p>Mithilfe der Option „Terminplan” kannst du einen Terminplan per Link veröffentlichen. Du legst fest, wann du für Meetings, Beratungen oder Gespräche verfügbar bist. Andere wählen aus den angebotenen Slots ihren Wunschtermin aus, ähnlich wie bei der Nextcloud-App „Appointments“.</p>
          <p>Klicke dazu auf das „Plus-Symbol“ rechts neben „Terminpläne“. Es öffnet sich ein neues Fenster, in dem du den Namen, einen Ort (z. B. einen Talk-Raum), den Kalender und die verfügbaren Zeiten festlegen kannst.</p>
           <BlogImage 
            src="/images/blog/Terminplan.png"
            alt="Kalender teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Kalender teilen"
            />

          <BlogHeading>Fazit</BlogHeading>
          <p>Mit dem Nextcloud Kalender stehen dir alle wichtigen Funktionen für die digitale Terminplanung zur Verfügung:</p>
          <ul className="list-disc pl-6">
            <li>Kalender flexibel erstellen und teilen</li>
            <li>Termine mit Videokonferenz-Link und Teilnehmerverwaltung</li>
            <li>Wiederkehrende Termine anlegen</li>
            <li>Gemeinsame freie Zeiten finden</li>
            <li>Ressourcen wie Räume oder Fahrzeuge einfach buchen</li>
            <li>Termine über Terminpläne zur Selbstbuchung anbieten</li>
          </ul>
          <p>Das alles läuft vollständig auf der Infrastruktur deiner Wahl – für maximale Kontrolle und Datenschutz.</p>
          
          <BlogSection title="Nextcloud bei PathConnect">
            <p>All diese Funktionen sind selbstverständlich in unserem Nextcloud-Angebot bei PathConnect enthalten.</p>
            <p>Wir kümmern uns um die Installation, individuelle Einrichtung und Wartung – damit du dich ganz auf deine Arbeit konzentrieren kannst.</p>
            <p>Mit PathConnect profitierst du von persönlichem Support, maßgeschneiderten Lösungen und vollem Datenschutz – egal, ob du Nextcloud für dein Team, dein Unternehmen oder für die Zusammenarbeit mit Kunden einsetzen möchtest.</p>
            <b>Du möchtest Nextcloud Kalender für dein Team nutzen? Sprich uns an – wir beraten dich gerne!</b>
          </BlogSection>
        </BlogContent>
      )
    },
    de_DE: {
      title: "Nextcloud Kalender – Die wichtigsten Funktionen im Überblick",
      formattedDate: "22. Juli 2025",
      excerpt: "Der Nextcloud-Kalender ermöglicht dir eine einfache und datenschutzfreundliche Organisation von Terminen, Meetings und Ressourcen.",
      searchableContent: "Nextcloud Kalender, Termine, Talk, Ressourcen, Terminplan, Kalender teilen, wiederkehrende Termine, Zeit finden, PathConnect",
      get content() { return post.translations.de.content; }
    }
    // Optional: Englische Übersetzung
  },

  get title() {
    return this.translations.de.title;
  },
  get formattedDate() {
    return this.translations.de.formattedDate;
  },
  get excerpt() {
    return this.translations.de.excerpt;
  },
  get content() {
    return this.translations.de.content;
  }
};

export default post;
